import { takeLatest, put, select } from 'redux-saga/effects'
import { actionTypes } from '../actions/cacheActions'
import { getListFoodAdded } from '../selectors/order'
import { ensureArray } from '../utils/helper'

function* _setListFood({ payload }) {
    const ordering = yield select(getListFoodAdded)

    const data = ensureArray(payload).map(food => {
        const hasInCart = ordering.some(f => f.foodDetails?.id === food.id)

        return {
            ...food,
            hasInCart
        }
    })

    yield put({
        type: actionTypes.SET_FOOD_CHOICE_SUCCESS,
        payload: data,
    })
}

const sagas = [takeLatest(actionTypes.SET_FOOD_CHOICE_REQ, _setListFood)]

export default sagas
